import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core'
import { Subscription } from 'rxjs'
import { fromEvent } from 'rxjs/internal/observable/fromEvent'
import { GeneralService } from './../../../services/general/general.service'

@Component({
  selector: 'app-input-field',
  templateUrl: './input-field.component.html',
  styleUrls: ['./input-field.component.scss'],
})
export class InputFieldComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() value: string | undefined
  @Input() type: 'text' | 'number' = 'text'
  @Input() placeholder: string | undefined
  @Input() showDeleteButton = true
  @Input() required = false
  @Input() autoFocus = false
  @Input() maxLength: number | undefined
  @Output() valueChange = new EventEmitter<string>()
  @Output() keyup = new EventEmitter<string>()

  isFocused = false
  private focusedElement: HTMLElement | undefined
  private focusSubscription: Subscription | undefined
  private blurSubscription: Subscription | undefined

  constructor(private elementRef: ElementRef, private generalService: GeneralService) {}

  ngOnInit() {
    const inputElem: HTMLElement = this.elementRef.nativeElement.querySelector('.input-field-wrapper input')
    if (inputElem) {
      this.subscribeEvents(inputElem)
    } else {
      const subscribeTimeout = setTimeout(() => {
        this.subscribeEvents(inputElem)
        clearTimeout(subscribeTimeout)
      }, 1000)
    }
  }

  ngOnDestroy(): void {
    if (this.focusSubscription !== undefined) {
      this.focusSubscription.unsubscribe()
    }
    if (this.blurSubscription !== undefined) {
      this.blurSubscription.unsubscribe()
    }
  }

  ngAfterViewInit(): void {
    if (this.autoFocus) {
      this.focusInputElem()
    }
  }

  onClickDeleteValue(): void {
    this.focusFakeInputElem()
    this.value = ''
    this.emitValue()
    this.focusInputElem()
  }

  onKeyUp(value: string): void {
    this.emitValue()
  }

  private emitValue(): void {
    this.valueChange.emit(this.value)
    this.keyup.emit(this.value)
  }

  private subscribeEvents(elem: HTMLElement): void {
    this.focusSubscription = fromEvent(elem, 'focus').subscribe((event: Event) => {
      this.onFocus(elem)
    })

    this.blurSubscription = fromEvent(elem, 'blur').subscribe((event: Event) => {
      this.onBlur()
    })
  }

  private focusInputElem(retryCount = 0): void {
    const inputElem: HTMLInputElement = this.elementRef.nativeElement.querySelector('.input-field-wrapper input')
    if (inputElem !== undefined) {
      const focusTimeout = setTimeout(() => {
        inputElem.focus()
        this.onFocus(inputElem)
        clearTimeout(focusTimeout)
      }, 350)
    } else {
      // 만약 inputElem 없을 시, 재시도. 재시도 10번 이상시 무시.
      if (retryCount >= 10) {
        return
      }
      const querySelectorTimeout = setTimeout(() => {
        this.focusInputElem(retryCount + 1)
        clearTimeout(querySelectorTimeout)
      })
    }
  }

  private focusFakeInputElem(): void {
    const fakeInputElem: HTMLInputElement = this.elementRef.nativeElement.querySelector('.fake-input')
    fakeInputElem?.focus()
  }

  private onFocus(elem: HTMLElement): void {
    this.isFocused = true
    this.focusedElement = elem
  }

  private onBlur(): void {
    const toggleFocusTimeout = setTimeout(() => {
      this.isFocused = false
      this.focusedElement = undefined
      clearTimeout(toggleFocusTimeout)
    }, 300)
  }
}
